module.exports = "/virtual-football-league/img/amblems/right/Germany/Fake_Leverkusen.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Germany/Fake_Leverkusen.png
// module id = 2141
// module chunks = 4